import { render } from "./ViewIlets.vue?vue&type=template&id=5afc16db&scoped=true"
import script from "./ViewIlets.vue?vue&type=script&lang=js"
export * from "./ViewIlets.vue?vue&type=script&lang=js"

import "@/assets/styles/ar/ViewThree.css?vue&type=style&index=0&id=5afc16db&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5afc16db"]])

export default __exports__